import jsPDF from "jspdf";
import { KulionerReceiptSectionProps, PDFDocument } from "./types";
import { createDocumentState } from "./utils";
import { renderHeader } from "./sections/header";
import { renderContactInfo } from "./sections/contact-info";
import { renderOrderDetails } from "./sections/order-details";
import { renderMerchantRecipient } from "./sections/merchant-recipient";
import { renderTable } from "./sections/table";
import { renderFooter } from "./sections/footer";
import { KulionerOrder } from "@/domain/entities/Kulioner";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { AccountController } from "@/app/ui/controllers/AccountController";

let currentReceiptStartPage = 2; // first page is empty and will be delete after generation completed
let importLogo: any;
let doc: PDFDocument | any;

const generateReceipt = async (data: KulionerOrder): Promise<void> => {
  const role = AccountController.accountData.account_type_detail?.type;
  try {
    importLogo = await import(`@/app/ui/assets/images/logo-${role}.png`);
  } catch (error) {
    console.warn(`Failed to load logo ${role}`);
  }

  // + 1 because first page is empty and will be delete after generation completed
  currentReceiptStartPage = doc.internal.getNumberOfPages() + 1;

  const state = createDocumentState();
  const { x } = state;
  let { y } = state;
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  doc.addPage();

  const onDrawPage = async () => {
    if (
      doc.internal.getCurrentPageInfo().pageNumber === currentReceiptStartPage
    ) {
      y = renderHeader(
        new KulionerReceiptSectionProps({ doc, x, y, pageWidth, importLogo })
      );
      y = renderContactInfo(new KulionerReceiptSectionProps({ doc, x, y }));
      y = renderOrderDetails(
        new KulionerReceiptSectionProps({ doc, x, y, pageWidth, data })
      );
      y = renderMerchantRecipient(
        new KulionerReceiptSectionProps({ doc, x, y, pageWidth, data })
      );
    }
  };

  await renderTable(doc, state.startYTable, data, onDrawPage);
  renderFooter(
    new KulionerReceiptSectionProps({ doc, pageWidth, pageHeight, data })
  );

  currentReceiptStartPage = doc.internal.getNumberOfPages() + 1;
};

const generateKulionerReceipt = async (data: KulionerOrder[]) => {
  try {
    MainAppController.showLoading();
    doc = new jsPDF("p", "mm", "a6", true) as PDFDocument;

    // Wait for all receipts to be generated
    for (const order of data) {
      await generateReceipt(order);
    }

    doc.setPage(doc.internal.getNumberOfPages());
    doc.deletePage(1);

    doc.setProperties({
      title: "Kulioner Receipt"
    });

    doc.autoPrint();

    // Cleanup
    const output = doc.output("bloburl");
    window.open(output, "_blank");
    // URL.revokeObjectURL(output); // commented coz cannot download the PDF file
  } catch (error) {
    console.error("Error generating PDF Kulioner:", error);
  } finally {
    MainAppController.closeLoading();
  }
};

export default generateKulionerReceipt;
